<template>
    <div>
        <div class="row mb-2">
            <span class="col-12 font-weight-bold font-small-5 text-muted">Pendataan dilakukan pada</span>
            <div class="col-12 mt-50 overflow-auto rounded">
                <template v-if="formDatas.keberadaan == 'luar'">
                    <div>
                        <span class="font-weight-bold font-small-5 text-muted">Lokasi ID</span>
                        <div class="border border-1 rounded p-75 bg-light mb-1">
                            <span>{{ formDatas.lokasi_id || '-' }}</span>
                        </div>
                    </div>
                    <div>
                        <span class="font-weight-bold font-small-5 text-muted">Jalan / Nomor</span>
                        <div class="border border-1 rounded p-75 bg-light mb-1">
                            <span>{{ formDatas.detail_lokasi.jalan || '-' }} / {{ formDatas.detail_lokasi.no_jalan || '-'
                            }}</span>
                        </div>
                    </div>
                    <div>
                        <span class="font-weight-bold font-small-5 text-muted">RT / RW</span>
                        <div class="border border-1 rounded p-75 bg-light mb-1">
                            <span>{{ formDatas.detail_lokasi.rt || '-' }} / {{ formDatas.detail_lokasi.rw || '-' }}</span>
                        </div>
                    </div>
                    <div>
                        <span class="font-weight-bold font-small-5 text-muted">Kelurahan</span>
                        <div class="border border-1 rounded p-75 bg-light mb-1">
                            <span>{{ formDatas.detail_lokasi.nm_kel || '-' }}</span>
                        </div>
                    </div>
                    <div>
                        <span class="font-weight-bold font-small-5 text-muted">Kecamatan</span>
                        <div class="border border-1 rounded p-75 bg-light mb-1">
                            <span>{{ formDatas.detail_lokasi.nm_kec || '-' }}</span>
                        </div>
                    </div>
                    <div>
                        <span class="font-weight-bold font-small-5 text-muted">Kota / Kabupaten</span>
                        <div class="border border-1 rounded p-75 bg-light mb-1">
                            <span>{{ formDatas.detail_lokasi.nm_rayon || '-' }}</span>
                        </div>
                    </div>
                    <div>
                        <span class="font-weight-bold font-small-5 text-muted">Kode Pos</span>
                        <div class="border border-1 rounded p-75 bg-light mb-1">
                            <span>{{ formDatas.detail_lokasi.kodepos || '-' }}</span>
                        </div>
                    </div>
                </template>
                <template v-else-if="formDatas.keberadaan == 'dalam'">
                    <div>
                        <span class="font-weight-bold font-small-5 text-muted">Ruangan ID</span>
                        <div class="border border-1 rounded p-75 bg-light mb-1">
                            <span>{{ formDatas.ruangan_id || '-' }}</span>
                        </div>
                    </div>
                    <div>
                        <span class="font-weight-bold font-small-5 text-muted">Gedung</span>
                        <div class="border border-1 rounded p-75 bg-light mb-1">
                            <span>{{
                                `${(formDatas.detail_ruangan.kobar_gedung) ? formDatas.detail_ruangan.kobar_gedung :
                                    ''}${(formDatas.detail_ruangan.nabar_gedung) ? '::' + formDatas.detail_ruangan.nabar_gedung :
                                        ''}${(formDatas.detail_ruangan.noreg_gedung) ? '::' + formDatas.detail_ruangan.noreg_gedung :
                                            ''}${(formDatas.detail_ruangan.alamat_gedung) ? '::' + formDatas.detail_ruangan.alamat_gedung : ''} ` || '-' }}
                            </span>
                        </div>
                    </div>
                    <div>
                        <span class="font-weight-bold font-small-5 text-muted">Lantai</span>
                        <div class="border border-1 rounded p-75 bg-light mb-1">
                            <span>{{ formDatas.detail_ruangan.lantai || '-' }}</span>
                        </div>
                    </div>
                    <div>
                        <span class="font-weight-bold font-small-5 text-muted">Jenis Ruangan</span>
                        <div class="border border-1 rounded p-75 bg-light mb-1">
                            <span>{{ formDatas.detail_ruangan.jenis_ruangan_nama || '-' }}</span>
                        </div>
                    </div>
                    <div>
                        <span class="font-weight-bold font-small-5 text-muted">Nama Ruangan</span>
                        <div class="border border-1 rounded p-75 bg-light mb-1">
                            <span>{{ formDatas.detail_ruangan.nama_ruangan || '-' }}</span>
                        </div>
                    </div>
                </template>
            </div>
        </div>
        <hr />
        <div class="row mb-2">
            <span class="col-12 font-weight-bold font-small-5 text-muted">Foto Barang</span>
            <div class="col-12 mt-50 overflow-auto rounded">
                <ImageView :imgUrl="formDatas.file_foto_barang || ''" />
            </div>
        </div>
        <div class="row mb-2">
            <span class="col-12 font-weight-bold font-small-5 text-muted">Kondisi</span>
            <div class="col-12 mt-50">
                <div class="d-flex flex-column mt-50 mt-md-0" style="gap:10px">
                    <b-form-radio v-model="formDatas.kondisi" value="baik" disabled>
                        Baik
                    </b-form-radio>
                    <b-form-radio v-model="formDatas.kondisi" value="rusak-ringan" disabled>
                        Rusak Ringan
                    </b-form-radio>
                    <b-form-radio v-model="formDatas.kondisi" value="rusak-berat" disabled>
                        Rusak Berat
                    </b-form-radio>
                </div>
            </div>
        </div>
        <hr />
        <div class="row mb-2">
            <span class="col-12 font-weight-bold font-small-5 text-muted">Kode dan Nama Barang</span>
            <div class="col-12 mt-50">
                <div class="border border-1 rounded p-75 bg-light mb-1">
                    <span>{{ (formDatas.kobar || '') + ' - ' + (formDatas.nabar || '') || '-' }}</span>
                </div>
            </div>
        </div>
        <hr />
        <div class="row mb-2">
            <span class="col-12 font-weight-bold font-small-5 text-muted">Bahan</span>
            <div class="col-12 mt-50">
                <div class="border border-1 rounded p-75 bg-light mb-1">
                    <span>{{ (formDatas.bahan || '') + ' - ' + (formDatas.nama_bahan || '') || '-' }}</span>
                </div>
            </div>
        </div>
        <hr />
        <div class="row mb-2">
            <span class="col-12 font-weight-bold font-small-5 text-muted">Merk</span>
            <div class="col-12 mt-50">
                <div class="border border-1 rounded p-75 bg-light mb-1">
                    <span>{{ formDatas.merk || '-' }}</span>
                </div>
            </div>
        </div>
        <hr />
        <div class="row mb-2">
            <span class="col-12 font-weight-bold font-small-5 text-muted">Tipe</span>
            <div class="col-12 mt-50">
                <div class="border border-1 rounded p-75 bg-light mb-1">
                    <span>{{ formDatas.tipe || '-' }}</span>
                </div>
            </div>
        </div>
        <hr />
        <div class="row mb-2">
            <span class="col-12 font-weight-bold font-small-5 text-muted">Apakah register merupakan bagian dari Aset
                Gelondongan ?</span>
            <div class="col-12 mt-50">
                <div class="d-flex flex-column mt-50 mt-md-0" style="gap:10px">
                    <b-form-radio v-model="formDatas.gelondongan" value="gelondongan" disabled>
                        Ya
                    </b-form-radio>
                    <div v-if="formDatas.gelondongan == 'gelondongan'"
                        style="margin-left: 25px;">
                        <div>
                            <span class="font-weight-bold font-small-5 text-muted">KIB</span>
                            <div class="border border-1 rounded p-75 bg-light mb-1">
                                <span>{{ formDatas.kib_gelondongan || '' }} - {{ formDatas.nama_kib_gelondongan || '' }}</span>
                            </div>
                        </div>
                        <div>
                            <span class="font-weight-bold font-small-5 text-muted">Kode Barang</span>
                            <div class="border border-1 rounded p-75 bg-light mb-1">
                                <span>{{ formDatas.kobar_gelondongan || '' }} - {{ formDatas.nabar_gelondongan || '' }}</span>
                            </div>
                        </div>
                        <div>
                            <span class="font-weight-bold font-small-5 text-muted">Register</span>
                            <div class="border border-1 rounded p-75 bg-light mb-1">
                                <span>{{ formDatas.noreg_gelondongan || '' }} - {{ formDatas.nabar_gelondongan || '' }}</span>
                            </div>
                        </div>
                        <div>
                            <span class="font-weight-bold font-small-5 text-muted">Total Harga</span>
                            <div class="border border-1 rounded p-75 bg-light mb-1">
                                <span>{{ formDatas.harga_gelondongan || '' }}</span>
                            </div>
                        </div>
                    </div>
                    <b-form-radio v-model="formDatas.gelondongan" value="non-gelondongan" disabled>
                        Tidak
                    </b-form-radio>
                </div>
            </div>
        </div>
        <hr />
        <div class="row mb-2">
            <span class="col-12 font-weight-bold font-small-5 text-muted">Penggunaan Barang</span>
            <div class="col-12 mt-50">
                <div class="d-flex flex-column mt-50 mt-md-0 mb-1" style="gap:10px">
                    <b-form-radio v-model="formDatas.penggunaan" value="digunakan-sendiri" disabled>
                        Digunakan Sendiri
                    </b-form-radio>
                    <div v-if="formDatas.penggunaan == 'digunakan-sendiri' && formDatas.digunakan_sendiri_mobile"
                        style="margin-left: 25px;">
                        <div>
                            <span class="font-weight-bold font-small-5 text-muted">Nama Pemakai</span>
                            <div class="border border-1 rounded p-75 bg-light mb-1">
                                <span>{{ formDatas.nama_pengguna || '-' }}</span>
                            </div>
                        </div>
                        <div>
                            <span class="font-weight-bold font-small-5 text-muted">Status Pemakai</span>
                            <div class="d-flex flex-column mt-50 mt-md-0 mb-1" style="gap:10px">
                                <b-form-radio v-model="formDatas.status_pemakai_pengguna" value="asn" disabled>
                                    ASN
                                </b-form-radio>
                                <b-form-radio v-model="formDatas.status_pemakai_pengguna" value="non-asn" disabled>
                                    NON ASN
                                </b-form-radio>
                            </div>
                        </div>
                        <div>
                            <span class="font-weight-bold font-small-5 text-muted">BAST Pemakai/Dokumen Lainnya</span>
                            <div class="d-flex flex-column mt-50 mt-md-0 mb-1" style="gap:10px">
                                <b-form-radio v-model="formDatas.is_bast_pengguna" value="ya" disabled>
                                    ADA
                                </b-form-radio>
                                <b-form-radio v-model="formDatas.is_bast_pengguna" value="tidak" disabled>
                                    TIDAK ADA
                                </b-form-radio>
                            </div>
                        </div>
                    </div>
                    <b-form-radio v-model="formDatas.penggunaan" value="pd-ukpd-lain" disabled>
                        PD/UKPD Lain
                    </b-form-radio>
                    <div v-if="formDatas.penggunaan == 'pd-ukpd-lain'" style="margin-left: 25px;">
                        <div>
                            <span class="font-weight-bold font-small-5 text-muted">Nama PD/UKPD</span>
                            <div class="border border-1 rounded p-75 bg-light mb-1">
                                <span>{{ (formDatas.kolok_pengguna || '') + ' - ' + (formDatas.nalok_pengguna || '') ||
                                    '-'
                                }}</span>
                            </div>
                        </div>
                    </div>
                    <b-form-radio v-model="formDatas.penggunaan" value="pemerintah-pusat" disabled>
                        Pemerintah Pusat
                    </b-form-radio>
                    <div v-if="formDatas.penggunaan == 'pemerintah-pusat'" style="margin-left: 25px;">
                        <div>
                            <span class="font-weight-bold font-small-5 text-muted">Nama Instansi</span>
                            <div class="border border-1 rounded p-75 bg-light mb-1">
                                <span>{{ formDatas.nama_pengguna || '-' }}</span>
                            </div>
                        </div>
                    </div>
                    <b-form-radio v-model="formDatas.penggunaan" value="pemerintah-daerah-lain" disabled>
                        Pemerintah Daerah Lain
                    </b-form-radio>
                    <div v-if="formDatas.penggunaan == 'pemerintah-daerah-lain'" style="margin-left: 25px;">
                        <div>
                            <span class="font-weight-bold font-small-5 text-muted">Nama Instansi</span>
                            <div class="border border-1 rounded p-75 bg-light mb-1">
                                <span>{{ formDatas.nama_pengguna || '-' }}</span>
                            </div>
                        </div>
                    </div>
                    <b-form-radio v-model="formDatas.penggunaan" value="pihak-lain" disabled>
                        Pihak Lain
                    </b-form-radio>
                    <div v-if="formDatas.penggunaan == 'pihak-lain'" style="margin-left: 25px;">
                        <div>
                            <span class="font-weight-bold font-small-5 text-muted">Nama Pihak Lain</span>
                            <div class="border border-1 rounded p-75 bg-light mb-1">
                                <span>{{ formDatas.nama_pengguna || '-' }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <hr />
        <div class="row mb-2">
            <span class="col-12 font-weight-bold font-small-5 text-muted">Keterangan</span>
            <div class="col-12 mt-50">
                <div class="border border-1 rounded p-75 bg-light mb-1">
                    <span>{{ formDatas.keterangan || '-' }}</span>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import { ref, watch, watchEffect, onMounted } from '@vue/composition-api'
import { id as localeId } from "vee-validate/dist/locale/id";
import { required } from '@validations'
import Ripple from 'vue-ripple-directive'
import { parserValue } from '@/libs/helper'
import ImageView from '@/components/base/ImageView'
export default {
    props: {
        fD: {
            type: Object,
            required: true,
        },
        disabled: { type: Boolean, default: false },
    },
    setup(props, context) {
        const g = context.root;
        const formDatas = ref({});
        watchEffect(() => {
            formDatas.value = props.fD
        });
        return {
            formDatas,
        }
    },
    computed: {
    },
    components: {
        ImageView
    },
    directives: {
        Ripple,
    },
    methods: {
    },

    data() {
        return {
            required,
        }
    },
}
</script>

<style lang="scss" scope>
.custom-control.custom-radio input:checked+.custom-control-label::before {
    /* Change this color to the desired color for the checked radio button */
    background-color: var(--indigo) !important;
}

.custom-control.custom-radio input:checked+.custom-control-label {
    /* Change this color to the desired color for the label text when checked */
    color: var(--text-dark) !important;
}
</style>